module.exports = __webpack_public_path__ + "static/32-05a18af28bb4716e69e88db456035582.png";